(() => {
  try {
    const EXPIRY_MS = 30 * 60 * 1000;
    const setSessionValue = (key, value) => {
      sessionStorage.setItem(key, value);
      sessionStorage.setItem(`${key}_expires`, String(Date.now() + EXPIRY_MS));
    };
    const getSessionValue = (key) => {
      const expires = parseInt(sessionStorage.getItem(`${key}_expires`) || '0', 10);
      if (!expires || Date.now() > expires) {
        sessionStorage.removeItem(key);
        sessionStorage.removeItem(`${key}_expires`);
        return '';
      }
      return sessionStorage.getItem(key) || '';
    };
    const setSessionValueOnce = (key, value) => {
      const existing = getSessionValue(key);
      if (existing) {
        return existing;
      }
      setSessionValue(key, value);
      return value;
    };
    const clearFebOfferSession = () => {
      try {
        sessionStorage.removeItem('ref');
        sessionStorage.removeItem('ref_expires');
        sessionStorage.removeItem('utm_campaign');
        sessionStorage.removeItem('utm_campaign_expires');
        sessionStorage.removeItem('campaignid');
        sessionStorage.removeItem('campaignid_expires');
      } catch (_) {}
    };
    const clearFreemagSession = () => {
      try {
        sessionStorage.removeItem('freemag_active');
        sessionStorage.removeItem('freemag_active_expires');
      } catch (_) {}
    };
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    const utmCampaign = params.get('utm_campaign');
    const campaignId = params.get('campaignid') || params.get('campaignId');
    const discount = params.get('discount');

    if (discount === 'FREEMAG') {
      clearFebOfferSession();
      setSessionValue('freemag_active', '1');
    } else if (ref !== null && utmCampaign !== null && campaignId !== null) {
      clearFreemagSession();
      setSessionValueOnce('ref', ref);
      setSessionValueOnce('utm_campaign', utmCampaign);
      setSessionValueOnce('campaignid', campaignId);
    }

    function isFebOfferActive() {
      return getSessionValue('utm_campaign') === 'FEBOFFER' && getSessionValue('ref') === 'social' && getSessionValue('campaignid') === '3d81bbdaccc3965c9e7be3ea8354ad7fa114ccb5';
    }
    function isFreemagActive() {
      return getSessionValue('freemag_active') === '1';
    }

    const FEBOFFER_MESSAGE_HTML = [
      '<span class="announcement-private-offer">',
      '<span class="announcement-private-offer__heading">You&#39;ve unlocked a Private Gift Card offer.</span>',
      '<span class="announcement-private-offer__body">Access via invitation only. Spend $150 and get a $30 gift card or spend $500 and get a $150 gift card.</span>',
      '<span class="announcement-private-offer__footer">Gift card sent with your order. Offer ends 31st March 2026 unless sold out earlier. Not valid with any other offer or discount. Not valid with subscription orders.</span>',
      '</span>',
    ].join('');

    const FREEMAG_MESSAGE_HTML = [
      '<span class="announcement-private-offer">',
      '<span class="announcement-private-offer__heading">You&#39;ve unlocked a free Magnesium Vitamin D2 Complex.</span>',
      '<span class="announcement-private-offer__body">Spend $120 or more and add it to your cart – it&#39;s free at checkout with code FREEMAG.</span>',
      '<span class="announcement-private-offer__footer">Not valid with subscription orders or other offers.</span>',
      '</span>',
    ].join('');

    function applyOfferAnnouncement() {
      const section = document.querySelector('.shopify-section--announcement-bar');
      if (!section) return;
      const bar = section.querySelector('[data-announcement-storage-key]');
      if (!bar) return;

      let messageHtml = null;
      if (isFebOfferActive()) {
        messageHtml = FEBOFFER_MESSAGE_HTML;
      } else if (isFreemagActive()) {
        messageHtml = FREEMAG_MESSAGE_HTML;
      }
      if (!messageHtml) return;

      bar.classList.add('announcement-bar--offer-active');
      const wrapper = section.querySelector('.announcement-bar__wrapper') || section.querySelector('.announcement-bar__scrolling-list');
      if (wrapper) {
        wrapper.innerHTML = messageHtml;
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyOfferAnnouncement);
    } else {
      applyOfferAnnouncement();
    }
  } catch (e) {
    // no-op
  }
})();
